import { useState } from '@adornis/functional-lit/stateful.js';
import type {
  EditorFrame,
  EditorLeftTab,
  EditorPreviewProfileId,
  EditorPropertiesTab,
  EditorTool,
} from './editorPageConfig.js';

export const useEditorShellState = () => {
  const [leftTab, setLeftTab] = useState<EditorLeftTab>('layers', []);
  const [leftPanelOpen, setLeftPanelOpen] = useState(true, []);
  const [propertiesTab, setPropertiesTab] = useState<EditorPropertiesTab>('design', []);
  const [rightPanelOpen, setRightPanelOpen] = useState(true, []);
  const [commentPanelRestore, setCommentPanelRestore] = useState<{ open: boolean; tab: EditorPropertiesTab } | null>(null, []);
  const [activeTool, setActiveTool] = useState<EditorTool>('select', []);
  const [activeFrame, setActiveFrame] = useState<EditorFrame>('desktop', []);
  const [activePreviewProfile, setActivePreviewProfile] = useState<EditorPreviewProfileId>('desktop', []);
  const [zoom, setZoom] = useState(0.72, []);
  const beginCommentPanel = () => { setCommentPanelRestore({ open: rightPanelOpen, tab: propertiesTab }); setRightPanelOpen(true); };
  const restoreCommentPanel = () => { if (!commentPanelRestore) return; setRightPanelOpen(commentPanelRestore.open); setPropertiesTab(commentPanelRestore.tab); setCommentPanelRestore(null); };
  return {
    activeFrame,
    activePreviewProfile,
    activeTool,
    beginCommentPanel,
    leftPanelOpen,
    leftTab,
    propertiesTab,
    rightPanelOpen,
    restoreCommentPanel,
    setActiveFrame,
    setActivePreviewProfile,
    setActiveTool,
    setLeftPanelOpen,
    setLeftTab,
    setPropertiesTab,
    setRightPanelOpen,
    setZoom,
    zoom,
  };
};
